module.exports = __webpack_public_path__ + "packshot_TCH.png";